import React from 'react'
import { Link } from 'react-router-dom'

const Content = ({ Page_title, button_title, button_status, route, additional_field, ...rest }) => {



  return (
    <div >
      <div className="content-body">
        <div className="container-fluid">
          <div className='wrapper-data'>
          <div className=" page-titles">
            {/* <div className='row mb-3'>
              <div className="col-lg-6"></div>
            </div> */}
            <ol className="breadcrumb justify-content-between">
              <div className="col-lg-6">
                <li className="breadcrumb-item">
                              <div className="d-flex align-items-center gap-3 flex-wrap">
                   {button_status !== false && button_title === "Back" && (
                     <Link
                       to={route}
                     
                     >
                       <i className="fa-solid fa-arrow-left me-1"></i>
                       {/* {button_title} */}
                     </Link>
                   )}
                 
                   <h3 className="font-w500 mb-1 mb-0">{Page_title}</h3>
                 </div>
                </li>
              </div>
                         {/* {button_status == false ? null : (
                           <div className="col-lg-6 ">
                             <Link
                               to={route}
                               className="btn  btn-sm btn-primary float-lg-end "
                               style={{ padding: "10px !important" }}
                             >
                               <i
                                 className={`fa-solid  ${
                                   button_title === "Back" ? "fa-arrow-left" : "fa-plus"
                                 } `}
                               ></i>{" "}
                               {button_title}
                             </Link>
                           </div>
                         )}  */}
              {/* Other buttons (like Add) on the right */}
             {button_status !== false && (
               <>
                
             
                 {/* Other buttons (like Add) on the right */}
                 {button_title !== "Back" && (
                   <div className="col-lg-6">
                     <Link
                       to={route}
                       className="btn btn-sm btn-primary float-lg-end"
                      
                     >
                       <i className="fa-solid fa-plus"></i> {button_title}
                     </Link>
                   </div>
                 )}
               </>
             )}
            </ol>
          </div>
          
                <div className="col-xl-12">
                  <div className="card form-card">
                    <div className="card-body">
                      <div className="form-validation">
                        {rest.children}
                      </div>
                    </div>
                  </div>


                </div>
                
                <div className="col-xl-12">
                  <div className="card form-card">
                    <div className="card-body">
                      <div className="form-validation">
                        {additional_field}
                      </div>
                    </div>
                  </div>
                </div>
             
</div>
    </div >
    </div>
      </div>          
  )
}

export default Content